var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_11)",
    filter: "url(#filter0_d_7_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 86C70.7482 86 90 66.7482 90 43C90 19.2518 70.7482 0 47 0C23.2518 0 4 19.2518 4 43C4 66.7482 23.2518 86 47 86Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4302 35.0138C52.826 34.2023 51.094 28.2169 52.5607 21.6456C53.5751 17.1018 58.5054 9.69609 61.4512 5.55835C62.5942 3.95261 64.0615 4.28313 64.4126 6.225C65.3174 11.23 66.6269 20.0408 65.6125 24.5846C64.1455 31.1559 60.0344 35.8257 56.4302 35.0138Z",
    fill: "#F7B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1673 36.1133C56.8105 36.1133 56.4549 36.0749 56.1016 35.9958C53.9572 35.5168 52.3103 33.6543 51.4635 30.7518C50.6806 28.067 50.6629 24.7492 51.4145 21.4103C52.4258 16.9163 56.9234 9.99998 60.5187 4.98969C61.3256 3.86554 62.3743 3.3516 63.3956 3.5809C64.4176 3.80903 65.1459 4.71993 65.3928 6.07849C66.4974 12.138 67.6011 20.305 66.5898 24.8006C65.0985 31.4283 61.1014 36.1133 57.1673 36.1133ZM56.5634 33.9413C59.5669 34.6075 63.2066 30.213 64.528 24.3397C65.5111 19.9703 64.1892 11.2585 63.3137 6.45499C63.1987 5.82245 62.9725 5.64478 62.9331 5.63548C62.8897 5.62827 62.6109 5.69408 62.2373 6.2143C59.3873 10.186 54.4593 17.5023 53.476 21.8712C52.8014 24.8695 52.8075 27.814 53.4926 30.1642C54.1145 32.2964 55.2051 33.6373 56.5634 33.9413Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5698 35.0138C41.174 34.2023 42.906 28.2169 41.4393 21.6456C40.4249 17.1018 35.4946 9.69609 32.5488 5.55835C31.4058 3.95261 29.9385 4.28313 29.5874 6.225C28.6826 11.23 27.3731 20.0408 28.3875 24.5846C29.8545 31.1559 33.9656 35.8257 37.5698 35.0138Z",
    fill: "#F6B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8328 36.1133C32.8987 36.1133 28.9019 31.4282 27.4104 24.8005C26.3987 20.3047 27.5026 12.1375 28.6074 6.07733C28.8543 4.71873 29.5826 3.80826 30.6046 3.58013C31.6259 3.35315 32.675 3.86478 33.4812 4.98849C37.0764 9.99941 41.5744 16.9159 42.5857 21.4101C43.3371 24.7491 43.3193 28.0668 42.5367 30.7519C41.6899 33.6545 40.043 35.517 37.8987 35.9961C37.5452 36.0751 37.1891 36.1133 36.8328 36.1133ZM31.075 5.63384C31.0717 5.63384 31.0684 5.6343 31.0666 5.63454C31.0267 5.64337 30.801 5.82128 30.686 6.45361C29.8103 11.2578 28.4884 19.9698 29.4717 24.3394C30.7936 30.2126 34.4434 34.6033 37.4362 33.9412C38.7947 33.6372 39.8855 32.2958 40.5074 30.1638C41.1925 27.814 41.1985 24.8689 40.5239 21.8705C39.5409 17.5019 34.6128 10.1852 31.7626 6.21267C31.4077 5.71849 31.1368 5.63384 31.075 5.63384Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9805 51.6962C22.9805 74.0007 33.7344 81.4648 47 81.4648C60.2656 81.4648 71.0195 74.0007 71.0195 51.6962C71.0195 29.3917 60.2656 19.8203 47 19.8203C33.7344 19.8203 22.9805 29.3919 22.9805 51.6962Z",
    fill: "#E5E1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9976 19.8203C46.8859 19.8203 46.7753 19.8268 46.6641 19.828V81.4588C46.7758 81.46 46.8859 81.4648 46.9976 81.4648C60.2645 81.4648 71.0195 74.0007 71.0195 51.6962C71.0195 29.3917 60.2645 19.8203 46.9976 19.8203Z",
    fill: "#E5E1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5801 82.9766C57.8512 82.9766 66.9883 77.0732 66.9883 69.791C66.9883 62.5088 57.8512 56.6055 46.5801 56.6055C35.3089 56.6055 26.1719 62.5088 26.1719 69.791C26.1719 77.0732 35.3089 82.9766 46.5801 82.9766Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9883 69.7912C66.9883 62.5232 57.8949 56.6293 46.6641 56.6055V82.9766C57.8949 82.9535 66.9883 77.0595 66.9883 69.7912Z",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1433 72.531C37.6648 72.531 38.8983 71.2975 38.8983 69.7759C38.8983 68.2543 37.6648 67.0208 36.1433 67.0208C34.6217 67.0208 33.3882 68.2543 33.3882 69.7759C33.3882 71.2975 34.6217 72.531 36.1433 72.531Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0563 72.531C58.5779 72.531 59.8114 71.2975 59.8114 69.7759C59.8114 68.2543 58.5779 67.0208 57.0563 67.0208C55.5348 67.0208 54.3013 68.2543 54.3013 69.7759C54.3013 71.2975 55.5348 72.531 57.0563 72.531Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5155 47.1007C37.5365 47.1007 38.3642 46.273 38.3642 45.252C38.3642 44.231 37.5365 43.4033 36.5155 43.4033C35.4944 43.4033 34.6667 44.231 34.6667 45.252C34.6667 46.273 35.4944 47.1007 36.5155 47.1007Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4846 47.1007C58.5056 47.1007 59.3333 46.273 59.3333 45.252C59.3333 44.231 58.5056 43.4033 57.4846 43.4033C56.4636 43.4033 55.6359 44.231 55.6359 45.252C55.6359 46.273 56.4636 47.1007 57.4846 47.1007Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0249 20.1271L47.0001 41.1874L50.9752 20.1271C49.6817 19.9241 48.3551 19.8185 47.0001 19.8185C45.645 19.8185 44.3186 19.9241 43.0249 20.1271Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9751 20.1271C49.6817 19.9241 48.355 19.8185 47 19.8185C46.8883 19.8185 46.7777 19.8236 46.6665 19.825V39.4209L47 41.1877L50.9751 20.1271Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7414 39.6281C69.4992 38.594 69.2244 37.6031 68.9186 36.6552L61.8015 41.1872L69.7414 39.6281Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8126 46.6358L64.4281 48.4425L70.9579 49.0045C70.9247 48.1968 70.8755 47.4077 70.8126 46.6358Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6173 58.6665C70.7318 57.722 70.8291 56.753 70.8944 55.7389L61.8018 57.0707L70.6173 58.6665Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2585 39.6281L32.1982 41.1877L25.0811 36.6556C24.7755 37.6033 24.5012 38.594 24.2585 39.6281Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5718 48.4425L23.1874 46.6358C23.1244 47.4077 23.0752 48.1968 23.042 49.0045L29.5718 48.4425Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3827 58.6665L32.1982 57.0709L23.1061 55.7391C23.1713 56.753 23.2682 57.722 23.3827 58.6665Z",
    fill: "#3A3A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7_11",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_11"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_11",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white",
    transform: "translate(4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ef970f1af7681471eaa05ed026dc5474.svg";
export { ForwardRef as ReactComponent };